<template>
    <div>
        <div class="wrapper" ref="scroller">
            <div class="content">
                <div
                    class="item"
                    v-for="item in localList"
                    :key="item"
                    @click="toMore(item)"
                >
                    <div class="cover">
                        <van-image
                            class="item-cover"
                            :class="{'songya-item-cover':coverType === 'songya'}"
                            :radius="size.radius"
                            :width="size.width"
                            :height="size.height"
                            fit="cover"
                            :src="item.cover"
                        />
                        <van-icon
                            name="play-circle-o"
                            class="video-logo"
                            v-if="coverType == 'video'"
                            :style="{ lineHeight: size.height }"
                        />
                    </div>
                    <div class="item-title">{{item.title}}</div>
                    <!-- 松雅主讲人 -->
                    <div v-if="coverType === 'songya'" class="songya-item-author">
                        {{item.author ? `主讲人：${item.author}` : ''}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import { onMounted, ref } from '@vue/runtime-core'
import { ellipsisString } from '@/utils/stringUtils'
import { Toast } from 'vant'

export default {
    name: 'ResourceListHor',
    props: {
        coverType: {
            type: String
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    setup() {
        // init BScroll
        const scroller = ref()
        onMounted(() => {
            const bs = new BScroll(scroller.value, {
                eventPassthrough: 'vertical',
                scrollX: true,
                probeType: 3,
                click: true
            })
            bs.on('scrollStart', () => {})
        })


        return {scroller}
    },
    methods:{
        toMore(item){
            if(!item.path) Toast.fail('未设置\npath')
            this.$router.push(item.path)
        }
    },
    computed:{
        size(){
            // init cover size
            const coverType = this.coverType
            let radius = ''
            let width = ''
            let height = ''
            switch(coverType) {
                case 'story':
                    radius = '5px'
                    width = '33vw'
                    height = '20vw'
                    break
                case 'personage':
                    radius = '50%'
                    width = '20vw'
                    height = '20vw'
                    break
                case 'book':
                    radius = '5px'
                    width = '25vw'
                    height = '37vw'
                    break
                case 'relic':
                    radius = '5px'
                    width = '65vw'
                    height = '33vw'
                    break
                case 'video':
                    radius = '5px'
                    width = '40vw'
                    height = '23vw'
                    break
                case 'songya':
                    radius = '10px'
                    width = '54.6vw'
                    height = '33vw'
                    break
            }
            return{
                radius,
                width,
                height
            }
        },
        localList(){
            // init list
            const list = this.list
            let localList = []
            if(list == null) return localList

            const coverType = this.coverType
            let max = 0
            switch(coverType) {
                case 'story':
                    max = 7
                    break
                case 'personage':
                    max = 4
                    break
                case 'book':
                    max = 5
                    break
                case 'relic':
                    max = 14
                    break
                case 'video':
                    max = 8
                    break
                case 'songya':
                    max = 10
                    break
            }

            list.forEach((item) => {
                item.title = ellipsisString(item.title, max)
                localList.push(item)
            })
            return localList
        }
    }
}
</script>

<style scoped>
.wrapper {
    width: 100vw;
    margin-left: -20px;
    white-space: nowrap;
    overflow: hidden;
}

.content {
    display: inline-block;
}

.item {
    display: inline-block;
    margin-left: 20px;
}

.item-title {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
}

.cover {
    position: relative;
}

.video-logo {
    font-size: 60px;
    font-weight: 600;
    position: absolute;
    width: 100%;
    text-align: center;
    color: #fff;
    left: 0;
    z-index: 1;
}
.songya-item-cover{
    box-shadow: 0 1px 18px 2px rgba(56, 56, 56, 0.1);
}
.songya-item-author{
    color:#4E4E4E;
    font-size: 0.8rem;
    font-weight: 500;
    height:4vw;
    line-height: 4vw;
    text-align: center;
}
</style>
